import { usePermissions } from "../../hooks/usePermissions";

/**
 * Renders children only when the user has the required permission(s).
 * Super admins always pass.
 */
export default function Can({ permission, anyOf, allOf, children, fallback = null }) {
  const { can, canAny, canAll } = usePermissions();

  let allowed = false;
  if (permission) {
    allowed = can(permission);
  } else if (anyOf?.length) {
    allowed = canAny(anyOf);
  } else if (allOf?.length) {
    allowed = canAll(allOf);
  } else {
    allowed = true;
  }

  return allowed ? children : fallback;
}
